import moment from 'moment';

import { addDaysToDateString, daysTo } from './date';

export const getRenewalStatus = candidateStatus => {
  switch (candidateStatus) {
    case 'completed':
      return 'compliant';
    case 'candidate':
      return 'pending';
    default:
      return candidateStatus;
  }
};

export const getNextRenewalDate = (renewalConfig, candidateCheck, outputFormat = 'DD/MM/YYYY') => {
  switch (renewalConfig.renewal_mode) {
    case 'use_expiration':
      return addDaysToDateString(
        candidateCheck.expiration_date,
        renewalConfig.frequency,
        'YYYY-MM-DD',
        outputFormat,
      );
    default: {
      const cadenceDate = addDaysToDateString(
        candidateCheck.completed_at,
        renewalConfig.frequency,
        'YYYY-MM-DD',
        'YYYY-MM-DD',
      );
      if (renewalConfig.renew_on_expiration && candidateCheck.expiration_date) {
        const effectiveDate =
          cadenceDate < candidateCheck.expiration_date
            ? cadenceDate
            : candidateCheck.expiration_date;
        return moment(effectiveDate, 'YYYY-MM-DD').format(outputFormat);
      }
      return addDaysToDateString(
        candidateCheck.completed_at,
        renewalConfig.frequency,
        'YYYY-MM-DD',
        outputFormat,
      );
    }
  }
};

export const daysToNextRenewal = (renewalConfig, candidateCheck) => {
  return daysTo(getNextRenewalDate(renewalConfig, candidateCheck), 'DD/MM/YYYY');
};
